// Increment C: a suspended company's respondents are paused; their answers are kept.
// Kept out of AssessmentPausedNotice.jsx so that file exports only a component (fast refresh).
export const ASSESSMENT_PAUSED_CODE = 'assessment_paused';
export const ASSESSMENT_PAUSED_MESSAGE = 'This assessment is paused. Contact the person who invited you.';
export const isAssessmentPaused = (err) => !!err && err.code === ASSESSMENT_PAUSED_CODE;
